var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 86,
    viewBox: "0 0 94 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M66.4965 11.2717L90.119 49.9977C99.0874 64.7005 89.4039 85.2713 70.6225 85.2713H23.3775C4.5962 85.2713 -5.08742 64.7006 3.88099 49.9978L27.5035 11.2717C36.4337 -3.36692 57.5663 -3.36692 66.4965 11.2717Z",
    fill: "#F6BE04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7687 14.1553L85.3912 52.8813C92.3103 64.2246 84.6994 79.7335 70.6223 79.7335H23.3773C9.30021 79.7335 1.68922 64.2246 8.60836 52.8814L32.2309 14.1553C39.0025 3.05501 54.9971 3.05501 61.7687 14.1553Z",
    fill: "#F6BE04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5163 17.3595L80.1388 56.0856C84.7344 63.6197 79.5599 73.5805 70.6227 73.5805H23.3777C14.4406 73.5805 9.26602 63.6197 13.8617 56.0856L37.4842 17.3595C41.8575 10.1907 52.143 10.1907 56.5163 17.3595Z",
    fill: "#F6BE04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9631 52.3284L43.41 33.8045C43.2441 31.8367 45.0248 30.2148 46.9997 30.2148C48.9746 30.2148 50.7553 31.8367 50.5894 33.8045L49.0363 52.3284C48.7822 55.348 45.2137 55.3233 44.9631 52.3284Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9999 57.8787C48.6659 57.8787 50.0177 59.2305 50.0177 60.8983C50.0177 62.5643 48.6659 63.9162 46.9999 63.9162C45.3321 63.9162 43.982 62.5643 43.982 60.8983C43.982 59.2305 45.3321 57.8787 46.9999 57.8787Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.285d01f6d48fed2cc52f0dbc05ab7eda.svg";
export { ForwardRef as ReactComponent };